$(document).ready(function(){
  $('.openFit').click(function(){
    $('body').addClass('lockScrolling')
    if($(window).width() < 1025){
      $('.fitSlide[data-index="2"] .fitSlideContent').addClass('alignLeft')
      if($('.fitSlide[data-index="1"]').hasClass('left')){
        $('.fitSlide[data-index="1"] .longSleeve').addClass('selected')
        $('.fitSlide[data-index="1"] .fitButton').addClass('clickable').text('continue')
        $('.typeSelect p:first-of-type strong').addClass('arrowSelect')
      }else if($('.fitSlide[data-index="1"]').hasClass('right')){
        $('.fitSlide[data-index="1"] .shortSleeve').addClass('selected')
        $('.fitSlide[data-index="1"] .fitButton').addClass('clickable').text('continue')
        $('.typeSelect p:last-of-type strong').addClass('arrowSelect')
      }else{
        $('.fitSlide[data-index="1"] .longSleeve').addClass('selected')
        $('.fitSlide[data-index="1"] .fitButton').addClass('clickable').text('continue')
        $('.typeSelect p:first-of-type strong').addClass('arrowSelect')
      }
      $('.fitSlide[data-index="1"] .fitButton').text('continue').addClass('clickable')
      $('.fitSlide[data-index="2"]').find('.fitButton').text('next')
    }

    //on click of fit button for slide 1 - MALE FEMALE
    $('.fitSlide[data-index="0"] .fitButton').click(function(){
      if($('.fitSlide[data-index="1"]').hasClass('left')){
        $('.fitSlide[data-index="1"] .longSleeve').addClass('selected')
        $('.fitSlide[data-index="1"] .fitButton').addClass('clickable').text('continue')
        $('.typeSelect p:first-of-type strong').addClass('arrowSelect')
      }else if($('.fitSlide[data-index="1"]').hasClass('right')){
        $('.fitSlide[data-index="1"] .shortSleeve').addClass('selected')
        $('.fitSlide[data-index="1"] .fitButton').addClass('clickable').text('continue')
        $('.typeSelect p:last-of-type strong').addClass('arrowSelect')
      }else{
        $('.fitSlide[data-index="1"] .longSleeve').addClass('selected')
        $('.fitSlide[data-index="1"] .fitButton').addClass('clickable').text('continue')
        $('.typeSelect p:first-of-type strong').addClass('arrowSelect')
      }
      if($('.fitSlide[data-index="0"]').hasClass('right')){
        $('.sizeSelect p:nth-of-type(2) strong, .waist strong').text('DRESS SIZE')
        $('.sizeInput input').val('')
        $('.chest input').val(1)
      }else{
        $('.sizeSelect p:nth-of-type(2) strong').text('CHEST')
        $('.waist strong').text('WAIST')
        $('.sizeInput input').val('')
        $('.chest input').val('')
      }
    });

    $('.panel--gender, .typeSelect p').click(function(){
      $('.sizeInput input').val('')
    })

    $('.fitSlide[data-index="1"] .fitButton').click(function(){
      $('.fitSlide[data-index="2"] .fitSlideContent').removeClass('alignMiddle alignRight').addClass('alignLeft')
      $('.sizeSelect .arrowSelect').removeClass('arrowSelect')
      $('.sizeSelect p:first-of-type').addClass('arrowSelect')
    });

    if($('.fitSlide[data-index="1"]').find('.selected').length > 0){
      $('.fitSlide[data-index="1"]').find('.fitButton').addClass('clickable')  
    }
    $('.fitSlide[data-index="2"]').find('.fitButton').removeClass('clickable')  
    $('.fitSlide[data-index="3"]').find('.fitButton').removeClass('clickable') 
    // open SizeFinder & show the first slide
    $('.fit').addClass('showFit')
    $('.fitSlide[data-index="0"]').addClass('showSlide')
//     $('.fitSlide[data-index="4"]').addClass('showSlide') age group
  })
  // set up back buttons for each slide
  $('.fitSlide[data-index="1"] .fitBack').click(function(){
    $(this).closest('.fitSlide').removeClass('showSlide').prev().addClass('showSlide')
    $(this).closest('.fitSlide').find('.fitButton').removeClass('clickable')
  })
  $('.fitSlide[data-index="2"] .fitBack').click(function(){
    $(this).closest('.fitSlide').removeClass('showSlide').prev().addClass('showSlide')
    $(this).closest('.fitSlide').find('.fitButton').removeClass('clickable')
  })
  $('.fitSlide[data-index="3"] .fitBack').click(function(){
    $(this).closest('.fitSlide').removeClass('showSlide').prev().addClass('showSlide')
    $(this).closest('.fitSlide').find('.fitButton').removeClass('clickable')
  })

  // SLIDE 0 M/F
  // switch logic on load
  if($('.fitSlide[data-index="0"] .switch input').prop('checked') == true){
    // female toggled ON
    $('.fitSlide[data-index="0"] .switch, .fitSlide[data-index="0"]').removeClass('left right').addClass('right')
    $('.fit').removeClass('male female').addClass('female')
    $('.panel--gender').removeClass('dim')
    $('.genderMale').addClass('dim')
    $('.waist p strong').text('Dress Size')
  } else {
    // male toggled ON
    $('.fitSlide[data-index="0"] .switch, .fitSlide[data-index="0"]').removeClass('left right').addClass('left')
    $('.fit').removeClass('male female').addClass('male')
    $('.panel--gender').removeClass('dim')
    $('.genderFemale').addClass('dim')
    $('.waist p strong').text('Waist')
  }
  // switch logic on toggle
  $('.fitSlide[data-index="0"] .switch input').change(function() {
    if ($('.fitSlide[data-index="0"] .switch input').prop('checked') == true) {
      // female toggled ON
      $('.fitSlide[data-index="0"] .switch, .fitSlide[data-index="0"]').removeClass('left right').addClass('right')
      $('.fit').removeClass('male female').addClass('female')
      $('.panel--gender').removeClass('dim')
      $('.genderMale').addClass('dim')
      $('.waist p strong').text('Dress Size')
      $('.female .mobile.sizeSelect p:nth-of-type(2) strong').text('Dress Size')
    } else {
      // male toggled ON
      $('.fitSlide[data-index="0"] .switch, .fitSlide[data-index="0"]').removeClass('left right').addClass('left')
      $('.fit').removeClass('male female').addClass('male')
      $('.panel--gender').removeClass('dim')
      $('.genderFemale').addClass('dim')
      $('.waist p strong').text('Waist')
      $('.female .mobile.sizeSelect p:nth-of-type(2) strong').text('Waist')
    }
  });
  // panel click handler
  $('.genderMale').click(function() {
    $('.fitSlide[data-index="0"] .switch, .fitSlide[data-index="0"]').removeClass('left right').addClass('left')
    $('.fit').removeClass('male female').addClass('male')
    $('.panel--gender').removeClass('dim')
    $('.genderFemale').addClass('dim')
    $('.waist p strong').text('Waist')
    $('.female .mobile.sizeSelect p:nth-of-type(2) strong').text('Waist')
    $('.fitSlide[data-index="0"] .switch input').prop( "checked", false )
  })
  $('.genderFemale').click(function() {
    $('.fitSlide[data-index="0"] .switch, .fitSlide[data-index="0"]').removeClass('left right').addClass('right')
    $('.fit').removeClass('male female').addClass('female')
    $('.panel--gender').removeClass('dim')
    $('.genderMale').addClass('dim')
    $('.waist p strong').text('Dress Size')
    $('.female .mobile.sizeSelect p:nth-of-type(2) strong').text('Dress Size')
    $('.fitSlide[data-index="0"] .switch input').prop( "checked", true )
  })
  // slide 0 continue logic
  $('.fitSlide[data-index="0"] .fitButton').addClass('clickable')
  $('.fitSlide[data-index="0"] .fitButton').click(function() {
    $(this).closest('.fitSlide').removeClass('showSlide').next().addClass('showSlide')
  });

  // logic for slide 1 continue button
  $('.fitSlide[data-index="1"] .fitButton').click(function(){
    // if an option has been selected
    if($(this).closest('.fitSlide').find('.selected').length > 0){
      // move to next slide & propagate choice appropriately throughout other slide data
      console.log($(this).closest('.fitSlide'))
      console.log($(this).closest('.fitSlide').next())
      $(this).closest('.fitSlide').removeClass('showSlide').next().addClass('showSlide')
      if($('.fitSlide[data-index="1"] .selected').hasClass('longSleeve')){
        $('.fitSlide[data-index="2"] .fitSlideContent, .fitSlide[data-index="3"] .fitSlideContent').removeClass('longSleeve shortSleeve').addClass('longSleeve')
        $('.fitSlide[data-index="3"] .fitProductTitle').text('dryrobe Advance Long sleeve')
      }else if($('.fitSlide[data-index="1"] .selected').hasClass('shortSleeve')){
        $('.fitSlide[data-index="2"] .fitSlideContent, .fitSlide[data-index="3"] .fitSlideContent').removeClass('longSleeve shortSleeve').addClass('shortSleeve')
        $('.fitSlide[data-index="3"] .fitProductTitle').text('dryrobe Advance Short sleeve')
      }else{
        $('.fitSlide[data-index="2"] .fitSlideContent, .fitSlide[data-index="3"] .fitSlideContent').removeClass('longSleeve shortSleeve')
      }
    }else{
      alert('Please choose a style.') 
    }

    // if next slide has already had values entered in the past, validate them now
    var check = 0;
    $('.fitSlide[data-index="2"]').find('.sizeInput input').each(function(){
      if(!$(this).hasClass('sizeInput--in') && $(this).val() == 0){
        check = 1;
      }
    })
    if(check == 0){
      $('.fitSlide[data-index="2"] .fitButton').addClass('clickable')
    }
  });
  // slide 1 hover states
  $('.fitSlide[data-index="1"] .panel--style').on("mouseenter", function(){
    $('.fitSlide[data-index="1"] .panel--style').not(this).addClass('dim')
  }).on("mouseleave", function(){
    $('.fitSlide[data-index="1"] .panel--style').removeClass('dim')
  });
  $('.fitSlide[data-index="1"] .panel--style').on("mouseenter", function(){
    $('.fitSlide[data-index="1"] .panel--style').not(this).addClass('dim')
  }).on("mouseleave", function(){
    $('.fitSlide[data-index="1"] .panel--style').removeClass('dim')
  });

  // logic for slide 2 continue button
  $('.fitSlide[data-index="2"] .fitButton').click(function(){
    var check = 0;
    $(this).closest('.fitSlide').find('.sizeInput input').each(function(){
      if($(this).hasClass('sizeInput--in')){
        if($('.fitSlide[data-index="2"]').hasClass('rightH')){
          if($(this).val() == ""){
            check = 1;
          }
        }
      }else{
        if($(this).val() == 0){
          check = 1;
        }
      }
    })
    if($('.fit').hasClass('female')){
      if($('.waist input').val()%2 == 0){

      }else{
        check = 1;
      }
    }
    if(check == 0){
      $(this).closest('.fitSlide').removeClass('showSlide').next().addClass('showSlide')
      $('.fitSlide[data-index="3"] .fitButton').addClass('clickable selectSize')
    }
  });
  // validate slide 2
  // Check all inputs have a size
  // Check dress size is a real dress size (divisible by 2)
  if($(window).width() < 1025){
    $('.fitSlide[data-index="2"] .sizeInput input').on('change keyup', function(){
      var check = 0;
      $(this).closest('.fitSlide').find('.sizeInput input').each(function(){
        if($(this).hasClass('sizeInput--in')){
          if($('.fitSlide[data-index="2"]').hasClass('rightH')){
            if($(this).val() == ""){
              check = 1;
            }
          }
        }else{
          if($(this).val() == 0){
            check = 1;
          }
        }
      })
      if($('.fit').hasClass('female')){
        if($('.waist input').val()%2 !== 0){
          check = 1;
        }
      }
      if(check == 0){
        $('.fitSlide[data-index="2"] .fitButton').text('continue').addClass('clickable')
      }else{
        $('.fitSlide[data-index="2"] .fitButton').text('next').removeClass('clickable')
      }
    });
    $('.fitSlide[data-index="2"] .fitSlideAction').click(function(){
      if($(this).find('.clickable').length < 1){
        if($('.fit').hasClass('female')){
          if($('.fitSlide[data-index="2"] .fitSlideContent').hasClass('alignLeft')){
            $('.sizeSelect p').eq(1).find('strong').click()
          }else if($('.fitSlide[data-index="2"] .fitSlideContent').hasClass('alignMiddle')){
            $('.sizeSelect p').eq(0).find('strong').click()
          }
        }else{
          if($('.fitSlide[data-index="2"] .fitSlideContent').hasClass('alignLeft')){
            $('.sizeSelect p').eq(1).find('strong').click()
          }else if($('.fitSlide[data-index="2"] .fitSlideContent').hasClass('alignMiddle')){
            $('.sizeSelect p').eq(2).find('strong').click()
          }else if($('.fitSlide[data-index="2"] .fitSlideContent').hasClass('alignRight')){
            $('.sizeSelect p').eq(0).find('strong').click()
          }
        }
      }
    });
  }else{
    $('.fitSlide[data-index="2"] .sizeInput input').on('change keyup', function(){

      var check = 0;
      $(this).closest('.fitSlide').find('.sizeInput input').each(function(){
        if($(this).hasClass('sizeInput--in')){
          if($('.fitSlide[data-index="2"]').hasClass('rightH')){
            if($(this).val() == ""){
              check = 1;
            }
          }
        }else{
          if($(this).val() == 0){
            check = 1;
          }
        }
      })
      if($('.fit').hasClass('female')){
        if($('.waist input').val()%2 !== 0){
          check = 1;
        }
      }
      if(check == 0){
        $('.fitSlide[data-index="2"] .fitButton').text('continue').addClass('clickable')
      }else{
        $('.fitSlide[data-index="2"] .fitButton').text('input measurements').removeClass('clickable')
      }
    });
  }
  // slide 3 end SlideFinder button
  $('.fitSlide[data-index="3"] .fitButton').click(function(){
    $(this).closest('.fitSlide').removeClass('showSlide')
    $('.fit').removeClass('showFit')
    $('body').removeClass('lockScrolling')
  });
  $('.fitClose').click(function(){
    $('.fit .showSlide').removeClass('showSlide')
    $('.fit').removeClass('showFit')
    $('body').removeClass('lockScrolling')
  });

  // slide 1 style switch click handler
  // short sleeve toggled ON
  if($('.fitSlide[data-index="1"] .switch input').prop('checked') == true){
    $('.fitSlide[data-index="1"] .switch, .fitSlide[data-index="1"]').removeClass('left right').addClass('right')
  }else{
    // long sleeve toggled ON
    $('.fitSlide[data-index="1"] .switch, .fitSlide[data-index="1"]').removeClass('left right').addClass('left')
  }
  // slide 1 style switch toggle handler
  $('.fitSlide[data-index="1"] .switch input').change(function(){
    if($('.fitSlide[data-index="1"] .switch input').prop('checked') == true){
      // short sleeve toggled ON
      $('.fitSlide[data-index="1"] .switch, .fitSlide[data-index="1"]').removeClass('left right').addClass('right')
      //$('.fit').removeClass('male female').addClass('female')
      $('.fitSlide .selected').removeClass('selected')
      $('.panel--style:first-child').addClass('permDim')
      $('.panel--style:last-child').removeClass('permDim')
      $('.panel--style:last-child').addClass('selected')
    }else{
      $('.fitSlide[data-index="1"] .switch, .fitSlide[data-index="1"]').removeClass('left right').addClass('left')
      //$('.fit').removeClass('male female').addClass('male')
      $('.fitSlide .selected').removeClass('selected')
      $('.panel--style:last-child').addClass('permDim')
      $('.panel--style:first-child').removeClass('permDim')
      $('.panel--style:first-child').addClass('selected')
    }
  });
  // slide 1 panel click handlers
  $('.fitSlide[data-index="1"] .fitSlideContent').children().click(function(){
    $('.fitSlide .selected').removeClass('selected')
    $(this).addClass('selected') 
    $(this).removeClass('permDim')
    $(this).siblings().addClass('permDim')
    // toggle the switch state & classes
    if($(this).hasClass('longSleeve')){
      $('.fitSlide[data-index="1"] .fitToggle .switch input').prop("checked", false)
      $('.fitSlide[data-index="1"] .fitSlide').addClass('left').removeClass('right')
      $('.fitSlide[data-index="1"] .switch').addClass('left').removeClass('right')
      $('.fitSlide[data-index="1"] .fitButton').text('continue').addClass('clickable')
    }else{
      $('.fitSlide[data-index="1"] .fitToggle .switch input').prop("checked", true)
      $('.fitSlide[data-index="1"] .fitSlide').removeClass('left').addClass('right')
      $('.fitSlide[data-index="1"] .switch').removeClass('left').addClass('right')
      $('.fitSlide[data-index="1"] .fitButton').text('continue').addClass('clickable')
    }
  })
  $('.fitSlide[data-index="1"] .mobile.typeSelect strong').click(function(){
    var i = $(this).parent().index()
    if(i == 0){
      $('.fitSlide[data-index="1"]').removeClass('left right').addClass('left')
    }else{
      $('.fitSlide[data-index="1"]').removeClass('left right').addClass('right')
    }
    $('.fitSlide .selected').removeClass('selected')
    $('.fitSlide[data-index="1"] .fitSlideContent').children().eq(i).addClass('selected')
    $('.fitSlide[data-index="1"] .fitButton').text('continue').addClass('clickable')

  });


  // slide 2 switch click handler
  if($('.fitSlide[data-index="2"] .fitInch .switch input').prop('checked') == true){
    $('.fitSlide[data-index="2"] .fitInch .switch, .fitSlide[data-index="2"]').removeClass('leftH rightH').addClass('rightH')
    $('.height .sizeInput h3').text('in')
    $('.sizeInput input').val('')
    if($('.fit').hasClass('female')){
      $('.chest .sizeInput input').val('1')
    }
  }else{
    $('.fitSlide[data-index="2"] .fitInch .switch, .fitSlide[data-index="2"]').removeClass('leftH rightH').addClass('leftH')
    $('.height .sizeInput h3').text('cm')
    $('.sizeInput input').val('')
    if($('.fit').hasClass('female')){
      $('.chest .sizeInput input').val('1')
    }
  }
  $('.fitSlide[data-index="2"] .fitInch .switch input').change(function(){
    if($('.fitSlide[data-index="2"] .fitInch .switch input').prop('checked') == true){
      $('.fitSlide[data-index="2"] .fitInch .switch, .fitSlide[data-index="2"]').removeClass('leftH rightH').addClass('rightH')
      $('.height .sizeInput h3').text('in')
      $('.sizeInput input').val('')
      if($('.fit').hasClass('female')){
        $('.chest .sizeInput input').val('1')
      }
    }else{
      $('.fitSlide[data-index="2"] .fitInch .switch, .fitSlide[data-index="2"]').removeClass('leftH rightH').addClass('leftH')
      $('.height .sizeInput h3').text('cm')
      $('.sizeInput input').val('')
      if($('.fit').hasClass('female')){
        $('.chest .sizeInput input').val('1')
      }
    }
    if($(window).width() < 1025){
      var check = 0;
      $(this).closest('.fitSlide').find('.sizeInput input').each(function(){
        if($(this).val() < 1){
          check = 1;
        }
      })
      if(check == 0){
        $('.fitSlide[data-index="2"] .fitButton').text('continue').addClass('clickable')
      }else{
        $('.fitSlide[data-index="2"] .fitButton').text('next').removeClass('clickable')
      }
    }else{
      var check = 0;
      $(this).closest('.fitSlide').find('.sizeInput input').each(function(){
        if($(this).val() < 1){
          check = 1;
        }
      })
      if(check == 0){
        $('.fitSlide[data-index="2"] .fitButton').text('continue').addClass('clickable')
      }else{
        $('.fitSlide[data-index="2"] .fitButton').text('input measurements').removeClass('clickable')
      }
    }
  });

  if($('.fitSlide[data-index="2"] .fitDress .switch input').prop('checked') == true){
    $('.fitSlide[data-index="2"] .fitDress .switch, .fitSlide[data-index="2"]').removeClass('leftD rightD').addClass('rightD')
    $('.waist .sizeInput h3').text('EU')
    $('.waist .sizeInput input').val('')
    $('.chest .sizeInput input').val('1')
    $('.waist input').attr({"step" : 2});
  }else{
    $('.fitSlide[data-index="2"] .fitDress .switch, .fitSlide[data-index="2"]').removeClass('leftD rightD').addClass('leftD')
    $('.waist .sizeInput h3').text('UK')
    $('.waist .sizeInput input').val('')
    $('.chest .sizeInput input').val('1')
    $('.waist input').attr({"step" : 2});
  }
  $('.fitSlide[data-index="2"] .fitDress .switch input').change(function(){
    if($('.fitSlide[data-index="2"] .fitDress .switch input').prop('checked') == true){
      $('.fitSlide[data-index="2"] .fitDress .switch, .fitSlide[data-index="2"]').removeClass('leftD rightD').addClass('rightD')
      $('.waist .sizeInput h3').text('EU')
      $('.waist .sizeInput input').val('')
      $('.chest .sizeInput input').val('1')
      $('.waist input').attr({ "step" : 2});
    }else{
      $('.fitSlide[data-index="2"] .fitDress .switch, .fitSlide[data-index="2"]').removeClass('leftD rightD').addClass('leftD')
      $('.waist .sizeInput h3').text('UK')
      $('.waist .sizeInput input').val('')
      $('.chest .sizeInput input').val('1')
      $('.waist input').attr({"step" : 2});
    }
    if($(window).width() < 1025){
      var check = 0;
      $(this).closest('.fitSlide').find('.sizeInput input').each(function(){
        if($(this).val() < 1){
          check = 1;
        }
      })
      if(check == 0){
        $('.fitSlide[data-index="2"] .fitButton').text('continue').addClass('clickable')
      }else{
        $('.fitSlide[data-index="2"] .fitButton').text('next').removeClass('clickable')
      }
    }else{
      var check = 0;
      $(this).closest('.fitSlide').find('.sizeInput input').each(function(){
        if($(this).val() < 1){
          check = 1;
        }
      })
      if(check == 0){
        $('.fitSlide[data-index="2"] .fitButton').text('continue').addClass('clickable')
      }else{
        $('.fitSlide[data-index="2"] .fitButton').text('input measurements').removeClass('clickable')
      }
    }
  });

  var sf = -1, lf = -1, z = 0;

  function sizeExplain(){
    $('.fitProductExplain').text('Unfortunately, your recommended size is not available for this product. Click the button below to view available products in your size.').css('margin-top', '20px').removeClass('hideExplain')
    $('.fitSlide[data-index="3"] .fitButton').text('VIEW AVAILABLE PRODUCTS')
  }

  function sizeExplainTypeShort(){
    $('.fitProductExplain').text('We noticed that you selected a short sleeve for your measurements. Click below to see all the short sleeve dryrobes in your recommended size.').css('margin-top', '20px').removeClass('hideExplain')
    $('.fitSlide[data-index="3"] .fitButton').text('VIEW AVAILABLE PRODUCTS')
  }

  function sizeExplainTypeLong(){
    $('.fitProductExplain').text('We noticed that you selected a long sleeve for your measurements. Click below to see all the long sleeve dryrobes in your recommended size.').css('margin-top', '20px').removeClass('hideExplain')
    $('.fitSlide[data-index="3"] .fitButton').text('VIEW AVAILABLE PRODUCTS')
  }

  function sizeExplainReset(){
    if ($('.fitProductExplain:contains("It looks like you could fit a couple of different sizes comfortably.")').length == 0) {
      $('.fitProductExplain').text('').css('margin-top', '0px').addClass('hideExplain')
    }
    $('.fitSlide[data-index="3"] .fitButton').text('SELECT SIZE')
  }

  function setResultContent(){

    if(!$('.fitSlide[data-index="3"] .switch input:checked').length){
//       console.log('lfit', lf)

      if(lf == 0){
        $('.fit').attr('data-size', 'xs')
        $('.lSize span').text('X-Small')
        if(!$('.swatch-element.xs').length || $('.swatch-element.xs').hasClass('soldout')){
          sizeExplain()
        }else{
          sizeExplainReset()
        }
      }else if(lf == 1){
        $('.fit').attr('data-size', 's')
        $('.lSize span').text('Small')
        if(!$('.swatch-element.s').length || $('.swatch-element.s').hasClass('soldout')){
          sizeExplain()
        }else{
          sizeExplainReset()
        }
      }else if(lf == 2){
        $('.fit').attr('data-size', 'm')
        $('.lSize span').text('Medium')
        if(!$('.swatch-element.m').length || $('.swatch-element.m').hasClass('soldout')){
          sizeExplain()
        }else{
          sizeExplainReset()
        }
      }else if(lf == 3){
        $('.fit').attr('data-size', 'l')
        $('.lSize span').text('Large')
        if(!$('.swatch-element.l').length || $('.swatch-element.l').hasClass('soldout')){
          sizeExplain()
        }else{
          sizeExplainReset()
        }
      }else if(lf == 4){
        $('.fit').attr('data-size', 'xl')
        $('.lSize span').text('X-Large')
        if(!$('.swatch-element.xl').length || $('.swatch-element.xl').hasClass('soldout')){
          sizeExplain()
        }else{
          sizeExplainReset()
        }
      }
    }else{
      console.log('sfit', sf)

      if(sf == 0){
        $('.fit').attr('data-size', 'xs')
        $('.sSize span').text('X-Small')
        if(!$('.swatch-element.xs').length || $('.swatch-element.xs').hasClass('soldout')){
          sizeExplain()
        }else{
          sizeExplainReset()
        }
      }else if(sf == 1){
        $('.fit').attr('data-size', 's')
        $('.sSize span').text('Small')
        if(!$('.swatch-element.s').length || $('.swatch-element.s').hasClass('soldout')){
          sizeExplain()
        }else{
          sizeExplainReset()
        }
      }else if(sf == 2){
        $('.fit').attr('data-size', 'm')
        $('.sSize span').text('Medium')
        if(!$('.swatch-element.m').length || $('.swatch-element.m').hasClass('soldout')){
          sizeExplain()
        }else{
          sizeExplainReset()
        }
      }else if(sf == 3){
        $('.fit').attr('data-size', 'l')
        $('.sSize span').text('Large')
        if(!$('.swatch-element.l').length || $('.swatch-element.l').hasClass('soldout')){
          sizeExplain()
        }else{
          sizeExplainReset()
        }
      }else if(sf == 4){
        $('.fit').attr('data-size', 'xl')
        $('.sSize span').text('X-Large')
        if(!$('.swatch-element.xl').length || $('.swatch-element.xl').hasClass('soldout')){
          sizeExplain()
        }else{
          sizeExplainReset()
        }
      }
    }

    if(lf == sf){
      $('.fitSlide[data-index="3"] .fitToggle').css('display', 'none')
    }else{
      $('.fitSlide[data-index="3"] .fitToggle').css('display', 'block')
    }

    if($('.product-single__title').text() == "dryrobe Advance Long Sleeve" && $('.shortSleeve.selected').length){
      sizeExplainTypeShort()
    }else if($('.product-single__title').text() == "dryrobe Advance Short Sleeve" && $('.longSleeve.selected').length){
      sizeExplainTypeLong()
    }
  }

  $('.fitSlide[data-index="2"] .fitButton').click(function(){
    $('.fitSlide[data-index="3"] .fitProductExplain').remove()
    var h = 0, c = 0, w = 0
    /*
    if($('.fit').hasClass('female')){
      if($('.fitSlide[data-index="2"]').hasClass('leftH')){
        h = $('.height input').val()
      }else{
        h = $('.height input').val() * 2.54
      }
      if($('.fitSlide[data-index="2"]').hasClass('leftD')){
        c = ($('.waist input').val() + 24) * 2.54, w = ($('.waist input').val() + 25) * 2.54;
      }else{
        c = ($('.waist input').val() - 2) * 2.54, w = ($('.waist input').val() -1) * 2.54;
      }
    }else{
    */
    // deal with size conversion cm inch
    if($('.fitSlide[data-index="2"]').hasClass('leftH')){
      h = $('.height input').val(), c = $('.chest input').val(), w = $('.waist input').val()
    }else{
      //h = $('.height input').val() * 2.54, c = $('.chest input').val() * 2.54, w = $('.waist input').val() * 2.54
      h = Math.floor((parseInt($('.height .sizeInput--ft').val())*12 + parseInt($('.height .sizeInput--in').val())) * 2.54), c = Math.floor($('.chest input').val() * 2.54), w = Math.floor($('.waist input').val() * 2.54)
      console.log('----------')
      console.log(h, c, w)
    }
    /*
    }
    */

    console.log(`Height: ${h}, Chest: ${c}, Waist: ${w}`)

    var ldif = 0
    var sdif = 0

    var lh = [], lc = [], lw = [], sh = [], sc = [], sw = [];
    var lhv = [[100, 135], [135, 157], [155, 178], [177, 191], [183, 203]], lcv = [[56, 67], [67, 86], [87, 101], [102, 109], [110, 125]], lwv = [[50, 58], [55, 71], [60, 81], [66, 110], [99, 117]], shv = [[100, 135], [135, 170], [160, 186], [179, 196], [194, 205]], scv = [[56, 67], [67, 99], [97, 115], [110, 125], [120, 140]], swv = [[50, 58], [55, 80], [71, 98], [88, 112], [113, 130]];

    lhv.forEach(function(item, index){
      if(h >= item[0] && h <= item[1]){
        lh.push(index)
      }
      if(index == 0){
        if(h < item[0]){
          lh.push(index)
        }
      }
      if(index == 4){
        if(h > item[1]){
          lh.push(index)
        }
      }
      console.log('lh', lh)
    });

    lcv.forEach(function(item, index){
      if(c >= item[0] && c <= item[1]){
        lc.push(index)
      }
      if(index == 0){
        if(c < item[0]){
          lc.push(index)
        }
      }
      if(index == 4){
        if(c > item[1]){
          lc.push(index)
        }
      }
    });

    lwv.forEach(function(item, index){
      if(w >= item[0] && w <= item[1]){
        lw.push(index)
      }
      if(index == 0){
        if(w < item[0]){
          lw.push(index)
        }
      }
      if(index == 4){
        console.log('item', item)
        if(w >= item[1]){
          lw.push(index)
        }
      }
    });

    shv.forEach(function(item, index){
      if(h >= item[0] && h <= item[1]){
        sh.push(index)
      }
      if(index == 0){
        if(h < item[0]){
          sh.push(index)
        }
      }
      if(index == 4){
        if(h > item[1]){
          sh.push(index)
        }
      }
    });

    scv.forEach(function(item, index){
      if(c >= item[0] && c <= item[1]){
        sc.push(index)
      }
      if(index == 0){
        if(c < item[0]){
          sc.push(index)
        }
      }
      if(index == 4){
        if(c > item[1]){
          sc.push(index)
        }
      }
    });

    swv.forEach(function(item, index){
      if(w >= item[0] && w <= item[1]){
        sw.push(index)
      }
      if(index == 0){
        if(w < item[0]){
          sw.push(index)
        }
      }
      if(index == 4){
        if(w > item[1]){
          sw.push(index)
        }
      }
    });

    if($('.fit').hasClass('female')){
      if($('.fitSlide[data-index="2"]').hasClass('leftD')){
        //uk
        if($('.waist input').val() <= 6){
          lw = [0], lc = [0]
        }else if ($('.waist input').val() == 8 || $('.waist input').val() == 10){
          lw = [1], lc = [1]
        }else if ($('.waist input').val() == 12 || $('.waist input').val() == 14){
          lw = [2], lc = [2]
        }else if ($('.waist input').val() == 16 || $('.waist input').val() == 18 || $('.waist input').val() == 20){
          lw = [3], lc = [3]
        }else if($('.waist input').val() >= 22){
          lw = [4], lc = [4]
        }

        if($('.waist input').val() <= 6){
          sw = [0], sc = [0]
        }else if ($('.waist input').val() == 8 || $('.waist input').val() == 10 || $('.waist input').val() == 12){
          sw = [1], sc = [1]
        }else if ($('.waist input').val() == 14 || $('.waist input').val() == 16){
          sw = [2], sc = [2]
        }else if ($('.waist input').val() == 18 || $('.waist input').val() == 20 || $('.waist input').val() == 22 || $('.waist input').val() == 24){
          sw = [3], sc = [3]
        }else if($('.waist input').val() >= 26){
          sw = [4], sc = [4]
        }

      }else{
        //eu
        if($('.waist input').val() <= 32){
          lw = [0], lc = [0]
        }else if ($('.waist input').val() == 34 || $('.waist input').val() == 36){
          lw = [1], lc = [1]
        }else if ($('.waist input').val() == 38 || $('.waist input').val() == 40){
          lw = [2], lc = [2]
        }else if ($('.waist input').val() == 42 || $('.waist input').val() == 44 || $('.waist input').val() == 46){
          lw = [3], lc = [3]
        }else if($('.waist input').val() >= 48){
          lw = [4], lc = [4]
        }

        if($('.waist input').val() <= 32){
          sw = [0], sc = [0]
        }else if ($('.waist input').val() == 34 || $('.waist input').val() == 36 || $('.waist input').val() == 38){
          sw = [1], sc = [1]
        }else if ($('.waist input').val() == 40 || $('.waist input').val() == 42){
          sw = [2], sc = [2]
        }else if ($('.waist input').val() == 44 || $('.waist input').val() == 46 || $('.waist input').val() == 48 || $('.waist input').val() == 50){
          sw = [3], sc = [3]
        }else if($('.waist input').val() >= 52){
          sw = [4], sc = [4]
        }

      }

    }

    var ls = [0, 0, 0, 0, 0], ss = [0, 0, 0, 0, 0]

    console.log('lh', lh)
    console.log('lc', lc)
    console.log('lw', lw)


    ls.forEach(function(item, index){
      var i = index
      lh.forEach(function(item, index){
        if(item == i){
          ls[i] = ls[i] + 1 
        }
      });
      lc.forEach(function(item, index){
        if(item == i){
          ls[i] = ls[i] + 1 
        }
      });
      lw.forEach(function(item, index){
        if(item == i){
          ls[i] = ls[i] + 1 
        }
      });
    })



    ss.forEach(function(item, index){
      var i = index
      sh.forEach(function(item, index){
        if(item == i){
          ss[i] = ss[i] + 1 
        }
      });
      sc.forEach(function(item, index){
        if(item == i){
          ss[i] = ss[i] + 1 
        }
      });
      sw.forEach(function(item, index){
        if(item == i){
          ss[i] = ss[i] + 1 
        }
      });
    })
    z = 0;
    var p = 0
    console.log('ss', ss)
    console.log('ls', ls)



    //lf = loose size 0 - 4
    //sf = slim size 0 - 4

    //reset lf and sf
    lf = -1, sf = -1

    // Loose logic
    if(lh.length == 1){
      //height has 1 value - use height
      lf = lh[0]
    }else{
      //height has more than 1 value - start comparing
      var lwl = 0, lcl = 0;
      if(lw.length == 1){
        lwl = lw[0]
      }else{
        lwl = lw[lw.length - 1]
      }
      if(lc.length == 1){
        lcl = lc[0]
      }else{
        lcl = lc[lc.length - 1]
      }
      console.log('waist top test 1', lwl, 'chest top test 1', lcl)
      if(lwl > lcl){
        //compare height and waist
        lh.forEach(function(item, index){
          if(lf < 0){
            //if compare has not found a result yet
            var tempItem = item
            lw.forEach(function(item, index){
              //compare the height that it is on to the all the waist values
              console.log('temp item', tempItem, 'item', item)
              if(item == tempItem){
                //Matched the height with the chest
                lf = item
                //break loop
                return false;
              }
            })
          }
        })
        if(lf < 0){
          //if no matches were found - see if waist is larger or smaller than height
          if(lwl < lh[0]){
            //use smallest height
            lf = lh[0]
          }else{
            //use largest height
            lf = lh[lh.length - 1]
          }
        }
      }else{
        // compare height and chest
        lh.forEach(function(item, index){
          if(lf < 0){
            //if compare has not found a result yet
            var tempItem = item
            lc.forEach(function(item, index){
              //compare the height that it is on to the all the chest values
              console.log('temp item', tempItem, 'item', item)
              if(item == tempItem){
                //Matched the height with the chest
                lf = item
                //break loop
                return false;
              }
            })
          }
        })
        if(lf < 0){
          //if no matches were found - see if waist is larger or smaller than height
          if(lcl < lh[0]){
            //use smallest height
            lf = lh[0]
          }else{
            //use largest height
            lf = lh[lh.length - 1]
          }
        }
      }
    }
    // end Loose logic

    //

    // Slim logic
    if(sh.length == 1){
      //height has 1 value - use height
      sf = sh[0]
    }else{
      //height has more than 1 value - start comparing
      var swl = 0, scl = 0;
      if(sw.length == 1){
        swl = sw[0]
      }else{
        swl = sw[sw.length - 1]
      }
      if(sc.length == 1){
        scl = sc[0]
      }else{
        scl = sc[sc.length - 1]
      }
      console.log('waist top 3', swl, 'chest top 3', scl)
      if(swl > scl){
        //compare height and waist
        sh.forEach(function(item, index){
          if(sf < 0){
            //if compare has not found a result yet
            var tempItem = item
            sw.forEach(function(item, index){
              //compare the height that it is on to the all the waist values
              console.log('temp item', tempItem, 'item', item)
              if(item == tempItem){
                //Matched the height with the chest
                sf = item
                //break loop
                return false;
              }
            })
          }
        })
        if(sf < 0){
          //if no matches were found - see if waist is larger or smaller than height
          if(swl < sh[0]){
            //use smallest height
            sf = sh[0]
          }else{
            //use largest height
            sf = sh[sh.length - 1]
          }
        }
      }else{
        // compare height and chest
        sh.forEach(function(item, index){
          if(sf < 0){
            //if compare has not found a result yet
            var tempItem = item
            sc.forEach(function(item, index){
              //compare the height that it is on to the all the chest values
              console.log('temp item', tempItem, 'item', item)
              if(item == tempItem){
                //Matched the height with the chest
                sf = item
                //break loop
                return false;
              }
            })
          }
        })
        console.log('sf result ', sf)
        if(sf < 0){
          //if no matches were found - see if waist is larger or smaller than height
          if(scl < sh[0]){
            //use smallest height
            sf = sh[0]
          }else{
            //use largest height
            sf = sh[sh.length - 1]
          }
        }
      }
    }
    // end Slim logic


    /*
//old logic
    ss.forEach(function(item, index){
      if(item > z){
        sf = index
        z = item
      }
    })
    ss.forEach(function(item, index){
      if(item == z){
        p++
      }
    })
    console.log('p', p)

    if(p > 1){
      var last_element = sh[sh.length-1]; // height largest value
      var temp = ss[last_element] //
      if(temp == z){
        ss.forEach(function(item, index){
          if(item == temp && index == last_element){
            sf = last_element
          }
        });
      }      
    }

    z = 0;
    //
    var p = 0
    console.log('ss', ss)
    console.log('ls', ls)

    ls.forEach(function(item, index){
      if(item > z){
        lf = index
        z = item
      }
    })
    //if tie
    p = 0;
    ls.forEach(function(item, index){
      if(item == z){
        p++
      }
    })
    console.log('p', p)

    if(p > 1){
      var last_element = lh[lh.length-1]; // height largest value
      var temp = ls[last_element] //
      if(temp == z){
        ls.forEach(function(item, index){
          if(item == temp && index == last_element){
            lf = last_element
          }
        });
      } 
    }    

    if(p == 1){

    }


    //if height has more than one value

    if(lh.length > 1){
      //get highest out of waist and chest
      if(lw[lw.length-1] < lc[lc.length-1]){
        //use chest
      }else{
        //use waist
      }
    }

*/

    setResultContent()

    //dif calc
    if(lh[0] > lc[0] && (lh[0] - lc[0]) >= 2){
      ldif = 1; 
    }
    if(lh[0] > lw[0] && (lh[0] - lw[0]) >= 2){
      ldif = 1; 
    }
    if(lw[0] > lc[0] && (lw[0] - lc[0]) >= 2){
      ldif = 1; 
    }
    if(lw[0] > lh[0] && (lw[0] - lh[0]) >= 2){
      ldif = 1; 
    }
    if(lc[0] > lw[0] && (lc[0] - lw[0]) >= 2){
      ldif = 1; 
    }
    if(lc[0] > lh[0] && (lc[0] - lh[0]) >= 2){
      ldif = 1; 
    }

    if(sh[0] > sc[0] && (sh[0] - sc[0]) >= 2){
      sdif = 1; 
    }
    if(sh[0] > sw[0] && (sh[0] - sw[0]) >= 2){
      sdif = 1; 
    }
    if(sw[0] > sc[0] && (sw[0] - sc[0]) >= 2){
      sdif = 1; 
    }
    if(sw[0] > sh[0] && (sw[0] - sh[0]) >= 2){
      sdif = 1; 
    }
    if(sc[0] > sw[0] && (sc[0] - sw[0]) >= 2){
      sdif = 1; 
    }
    if(sc[0] > sh[0] && (sc[0] - sh[0]) >= 2){
      sdif = 1; 
    }

    if($('.fitSlide[data-index="1"]').hasClass('left')){
      if(ldif == 1){
        $('<div class="fitProductExplain" style="margin-bottom: 20px;">It looks like you could fit a couple of different sizes comfortably. Please <a href="/pages/contact-us">call or email us</a> for a personal size recommendation. This will help you get the right fit for your use.</div>').insertAfter($('.fitSlide[data-index="3"] .fitSlideContent .fitProductSize'))
      }
    }else{
      if(sdif == 1){
        $('<div class="fitProductExplain" style="margin-bottom: 20px;">It looks like you could fit a couple of different sizes comfortably. Please call or email us for a personal size recommendation. This will help you get the right fit for your use.</div>').insertAfter($('.fitSlide[data-index="3"] .fitSlideContent .fitProductSize'))
      }
    }
    console.log('ldif', ldif, ' sdif', sdif)
    //end dif calc


    //change slide 3 based on logic


  });

  if($('.fitSlide[data-index="3"] .switch input').prop('checked') == true){
    $('.fitSlide[data-index="3"] .switch, .fitProductSize').removeClass('left right').addClass('right')
    $('.fitSlide[data-index="3"] .fitProductDescription').text('Great for keeping warm and dry, where changing space is not required.')
    setResultContent()
  }else{
    $('.fitSlide[data-index="3"] .switch, .fitProductSize').removeClass('left right').addClass('left')
    $('.fitSlide[data-index="3"] .fitProductDescription').text('A loose fit that will allow easy changing while staying dry, warm and protected from the elements.')
    setResultContent()
  }
  $('.fitSlide[data-index="3"] .switch input').change(function(){
    if($('.fitSlide[data-index="3"] .switch input').prop('checked') == true){
      $('.fitSlide[data-index="3"] .switch, .fitProductSize').removeClass('left right').addClass('right')
      $('.fitSlide[data-index="3"] .fitProductDescription').text('Great for keeping warm and dry, where changing space is not required.')
      setResultContent()
    }else{
      $('.fitSlide[data-index="3"] .switch, .fitProductSize').removeClass('left right').addClass('left')
      $('.fitSlide[data-index="3"] .fitProductDescription').text('A loose fit that will allow easy changing while staying dry, warm and protected from the elements.')
      setResultContent()
    }
  });

  function results(){
    if($('.fitSlide[data-index="3"] .switch input').prop('checked') == true){
      console.log(`Saving slim fit recommendation to session storage. sf: ${sf} lf: ${lf}`);
      sessionStorage.setItem('recommended_size', sf);
      if($('.fitSlide[data-index="1"] .selected').hasClass('shortSleeve')){
        window.location.href = "/pages/fit-recommender-results?type=short&size="+sf;
      }else{
        window.location.href = "/pages/fit-recommender-results?type=long&size="+sf;
      }
    }else{
      console.log(`Saving loose fit recommendation to session storage. sf: ${sf} lf: ${lf}`);
      sessionStorage.setItem('recommended_size', lf);
      if($('.fitSlide[data-index="1"] .selected').hasClass('shortSleeve')){
        window.location.href = "/pages/fit-recommender-results?type=short&size="+lf;
      }else{
        window.location.href = "/pages/fit-recommender-results?type=long&size="+lf;
      }
    } 
  }

  function scrollToAddToCartButton() {
    $('html, body').animate({
      scrollTop: $('#AddToCart-product-template').offset().top - $(window).height() + $('#AddToCart-product-template').height() + 40
    }, 1500);
  }

  function logRecommendedSize() {
    if (!$('.fitSlide[data-index="3"] .switch input:checked')) {
      sessionStorage.setItem('recommended_size', lf);
    } else {
      sessionStorage.setItem('recommended_size', sf);
    }
  }

  $('.fitSlide[data-index="3"] .fitButton').click(function(){
    if($('.product-single__title').text() == "dryrobe Advance Long Sleeve" && $('.shortSleeve.selected').length){
      results()
    }else if($('.product-single__title').text() == "dryrobe Advance Short Sleeve" && $('.longSleeve.selected').length){
      results()
    }else{
      if($('.fitSlide[data-index="3"] .switch input:checked').length){
        console.log('ticked', sf)
        if(sf == 0){
          if($('.swatch-element.xs').length && !$('.swatch-element.xs').hasClass('soldout')){
            sessionStorage.setItem('recommended_size', sf);
            $('.swatch-element.xs').click()
            $('.swatch-element.xs').find('input').prop("checked", true).trigger('click');
            $('#SingleOptionSelector-0').val('XS').trigger('change');
          }else{
            results()
          }
        }else if(sf == 1){
          if($('.swatch-element.s').length && !$('.swatch-element.s').hasClass('soldout')){
            sessionStorage.setItem('recommended_size', sf);
            $('.swatch-element.s').click()
            $('.swatch-element.s').find('input').prop("checked", true).trigger('click');
            $('#SingleOptionSelector-0').val('S').trigger('change');
          }else{
            results()
          }
        }else if(sf == 2){
          if($('.swatch-element.m').length && !$('.swatch-element.m').hasClass('soldout')){
            sessionStorage.setItem('recommended_size', sf);
            $('.swatch-element.m').click()
            $('.swatch-element.m').find('input').prop("checked", true).trigger('click');
            $('#SingleOptionSelector-0').val('M').trigger('change');
          }else{
            results()
          }
        }else if(sf == 3){
          if($('.swatch-element.l').length && !$('.swatch-element.l').hasClass('soldout')){
            sessionStorage.setItem('recommended_size', sf);
            $('.swatch-element.l').click()
            $('.swatch-element.l').find('input').prop("checked", true).trigger('click');
            $('#SingleOptionSelector-0').val('L').trigger('change');
          }else{
            results()
          }
        }else if(sf == 4){
          if($('.swatch-element.xl').length && !$('.swatch-element.xl').hasClass('soldout')){
            sessionStorage.setItem('recommended_size', sf);
            $('.swatch-element.xl').click()
            $('.swatch-element.xl').find('input').prop("checked", true).trigger('click');
            $('#SingleOptionSelector-0').val('XL').trigger('change');
          }else{
            results()
          }
        }
      }else{
        console.log('not ticked', lf)
        if(lf == 0){
          if($('.swatch-element.xs').length && !$('.swatch-element.xs').hasClass('soldout')){
            sessionStorage.setItem('recommended_size', sf);
            $('.swatch-element.xs').click()
            $('.swatch-element.xs').find('input').prop("checked", true).trigger('click');
            $('#SingleOptionSelector-0').val('XS').trigger('change');
          }else{
            results()
          }
        }else if(lf == 1){
          if($('.swatch-element.s').length && !$('.swatch-element.s').hasClass('soldout')){
            sessionStorage.setItem('recommended_size', lf);
            $('.swatch-element.s').click()
            $('.swatch-element.s').find('input').prop("checked", true).trigger('click');
            $('#SingleOptionSelector-0').val('S').trigger('change');
          }else{
            results()
          }
        }else if(lf == 2){
          if($('.swatch-element.m').length && !$('.swatch-element.m').hasClass('soldout')){
            sessionStorage.setItem('recommended_size', lf);
            $('.swatch-element.m').click()
            $('.swatch-element.m').find('input').prop("checked", true).trigger('click');
            $('#SingleOptionSelector-0').val('M').trigger('change');
          }else{
            results()
          }
        }else if(lf == 3){
          if($('.swatch-element.l').length && !$('.swatch-element.l').hasClass('soldout')){
            sessionStorage.setItem('recommended_size', lf);
            $('.swatch-element.l').click()
            $('.swatch-element.l').find('input').prop("checked", true).trigger('click');
            $('#SingleOptionSelector-0').val('L').trigger('change');
          }else{
            results()
          }
        }else if(lf == 4){
          if($('.swatch-element.xl').length && !$('.swatch-element.xl').hasClass('soldout')){
            sessionStorage.setItem('recommended_size', lf);
            $('.swatch-element.xl').click()
            $('.swatch-element.xl').find('input').prop("checked", true);
            $('#SingleOptionSelector-0').val('XL').trigger('change').trigger('click');
          }else{
            results()
          }
        }
      }
    }
    if ($( window ).width() < 768) {
      scrollToAddToCartButton();
    }
  });

  //mobile JS
  $('.typeSelect p:first-of-type strong').addClass('arrowSelect')
  $('.fitSlide[data-index="1"] .fitSlideContent').addClass('alignLeft')
  $('.typeSelect strong').click(function(){
    $('.fitSlide[data-index="1"] .arrowSelect').removeClass('arrowSelect')
    $(this).addClass('arrowSelect')
  });
  $('.typeSelect strong').eq(0).click(function(){
    $('.alignRight').removeClass('alignRight').addClass('alignLeft')
  });
  $('.typeSelect strong').eq(1).click(function(){
    $('.alignLeft').removeClass('alignLeft').addClass('alignRight')
  });

  $('.sizeSelect p').eq(0).addClass('arrowSelect')

  $('.sizeSelect p').eq(0).click(function(){
    $('.fitSlide[data-index="2"] .arrowSelect').removeClass('arrowSelect')
    $(this).addClass('arrowSelect')
    $('.fitSlide[data-index="2"] .fitSlideContent').removeClass('alignLeft alignMiddle alignRight').addClass('alignLeft')

  });

  $('.sizeSelect p').eq(1).click(function(){
    $('.fitSlide[data-index="2"] .arrowSelect').removeClass('arrowSelect')
    $(this).addClass('arrowSelect')
    $('.fitSlide[data-index="2"] .fitSlideContent').removeClass('alignLeft alignMiddle alignRight').addClass('alignMiddle')

  });

  $('.sizeSelect p').eq(2).click(function(){
    $('.fitSlide[data-index="2"] .arrowSelect').removeClass('arrowSelect')
    $(this).addClass('arrowSelect')
    $('.fitSlide[data-index="2"] .fitSlideContent').removeClass('alignLeft alignMiddle alignRight').addClass('alignRight')

  });

  //logic for slide 1 mobile toggle buttons
  $('.fitSlide[data-index="0"] .typeSelect p:first-of-type strong').click(function(){
    $('.fit').removeClass('female').addClass('male')
    $('.fitSlide[data-index="0"]').removeClass('right').addClass('left')
    $('.genderMale').removeClass('dim')
    $('.genderFemale').addClass('dim')
  })

  $('.fitSlide[data-index="0"] .typeSelect p:last-of-type strong').click(function(){
    $('.fit').removeClass('male').addClass('female')
    $('.fitSlide[data-index="0"]').removeClass('left').addClass('right')
    $('.genderMale').addClass('dim')
    $('.genderFemale').removeClass('dim')
  })
})

//20/06 edits
$(document).ready(function(e){
  $('body').on('click', '.sCover', function(e){
    e.preventDefault();
    e.stopPropagation();
  })
});